import React, { FC } from 'react'
import { Flex } from '@components/gassan-ui'
import styled from 'styled-components'
import { rem } from 'polished'
import americanExpress from './assets/american_express.svg'
import bancontact from './assets/bancontact.svg'
import ideal from './assets/ideal.svg'
import mastercard from './assets/mastercard.svg'
import paypal from './assets/paypal.svg'
import visa from './assets/visa.svg'

const Logo = styled.img`
  height: ${rem(21)};
  width: auto;
`

const Logos: FC = () => {
  return (
    <Flex justifyContent="space-between">
      <Logo src={americanExpress} alt="American Express" />
      <Logo src={ideal} alt="iDeal" />
      <Logo src={mastercard} alt="Mastercard" />
      <Logo src={visa} alt="Visa" />
      <Logo src={bancontact} alt="Bancontact" />
      <Logo src={paypal} alt="Paypal" />
    </Flex>
  )
}

export default Logos
